import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import usePiwik from 'src/hooks/usePiwik'
import { actions as followUpPromptsActions } from 'src/features/fw-ai/children/followUpPrompts/FollowUpPromptsSlice'
import FollowUpPrompts from 'src/features/fw-ai/children/followUpPrompts/FollowUpPrompts'
import PropTypes from 'prop-types'
import {
  getFetching,
  getPrompts
} from 'src/features/fw-ai/children/followUpPrompts/FollowUpPromptsSelector'
import { siteName } from 'src/utils/oneCodeBase'

const FollowUpContainer = ({ articleId }) => {
  const dispatch = useDispatch()
  const isFetching = useSelector(getFetching())
  const followUpPrompts = useSelector(getPrompts())

  const { handleActionTracking } = usePiwik()
  const pharmaBaseUrl = process.env.REACT_APP_WEBSITE_URL_PHARMA
  const customStyles = {
    borderRadius: '10px',
    marginTop: 2,
    marginBottom: 2,
    padding: '15px 15px 0 15px',
    flexShrink: 0
  }

  useEffect(() => {
    dispatch(followUpPromptsActions.requestPrompts({ articleId }))
  }, [])

  const handlePromptClick = ({ prompt, pos }) => {
    const encodedPrompt = encodeURIComponent(prompt)

    const targetUrl = siteName === 'Pharma' ? '/' : pharmaBaseUrl

    // Handle FirstWord AI redirection
    window.open(
      `${targetUrl}firstword-ai?preprompt=${encodedPrompt}`,
      '_blank',
      'noopener,noreferrer'
    )

    // Piwik tracking
    handleActionTracking('Site/Click/Article/followup-prompt', {
      pos
    })
  }

  return (
    <FollowUpPrompts
      title="Go Beyond the Story with FirstWord AI"
      isFetching={isFetching}
      prompts={followUpPrompts}
      onPromptClick={handlePromptClick}
      containerSx={customStyles}
    />
  )
}

FollowUpContainer.propTypes = {
  articleId: PropTypes.string.isRequired
}

export default FollowUpContainer
